import { Button, Headline1, Meta, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import Icon from '../icons/Icon';

type NoMatchesProps = {
  onButtonClick?: () => void;
  buttonText?: string;
  testID?: string;
};

const LocationIcon = () => (
  <Icon name="Location-Filled-01" size="s" color={theme.colors.white} />
);

const NoMatches: React.FC<NoMatchesProps> = ({
  onButtonClick,
  buttonText,
  testID = 'no-matches',
}) => {
  const { t } = useTranslation();

  return (
    <StyledWrapper alignItems="center" mt={20} flex={1} testID={testID}>
      <Headline1>{t('search.noMatches')}</Headline1>
      <StyledWrapper>
        <Meta center>{t('search.noMatchesText')}</Meta>
      </StyledWrapper>
      <StyledWrapper maxWidth={266}>
        <Button
          onPress={onButtonClick}
          text={buttonText || t('search.seeNearbyButton')}
          iconComponent={LocationIcon}
          iconRight
          size="m"
        />
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default NoMatches;
